import { jsx as _jsx } from "react/jsx-runtime";
import { App } from "antd";
import { useCallback } from "react";
import { Popconfirm } from "@devowl-wp/react-folder-tree";
import { useStores } from "../../store/rootStore.js";
import { TreeStore } from "../../store/treeStore.js";
import { __ } from "../../utils/i18n.js";
function useTrashNode(handleSelect) {
    const { message } = App.useApp();
    const { treeStore } = useStores();
    /**
     * Handle trashing of a category. If the category has subcategories, trashing is forbidden.
     */ const handleTrash = useCallback(async ()=>{
        const { selected } = treeStore;
        if (!selected) {
            return;
        }
        // Check if subdirectories
        if (selected.childNodes.filter((n)=>n.$visible).length) {
            message.error(__('You can not delete "%s" because it contains subcategories.', [
                selected.title
            ]));
            return;
        }
        const hide = message.loading(__('Deleting "%s"...', selected.title));
        try {
            await selected.trash();
            message.success(__('"%s" successfully deleted.', selected.title));
            // Select parent
            handleSelect(selected.parent?.id || TreeStore.ID_ALL);
        } catch (e) {
            message.error(e.responseJSON.message);
        } finally{
            hide();
        }
    }, [
        handleSelect,
        message,
        treeStore
    ]);
    /**
     * When opening the trash symbol in the toolbar do a Popconfirm instead of simple click.
     */ const handleTrashModifier = useCallback((body)=>{
        const { selected, selectedId } = treeStore;
        return selected && selectedId !== TreeStore.ID_ALL ? /*#__PURE__*/ _jsx(Popconfirm, {
            styles: {
                root: {
                    maxWidth: 254
                }
            },
            placement: "bottom",
            onConfirm: handleTrash,
            title: __('Are you sure you want to delete "%s"? Note: The posts in this category will NOT be deleted automatically.', [
                selected.title
            ]),
            okText: __("OK"),
            cancelText: __("Cancel"),
            children: body
        }) : body;
    }, [
        handleTrash,
        treeStore
    ]);
    return {
        handleTrash,
        handleTrashModifier
    };
}
export { useTrashNode };
